/** 
*@author: satyamurthy.a
*@Description : 
**/
import { connect } from 'react-redux';
import { Input, Popconfirm,Button,Tooltip } from 'antd';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { encode as base64_encode } from 'base-64';
import { constant } from '../../../Utils/constants';
import React, { useState, useEffect, useRef } from 'react';
import translation from '../../../../../commons/translation';

import { API_MASTERMATERIALS } from '../../../../../commons/api';
import { getMasterList, deleteMaster } from '../../../Utils/FormCalls';
import {
  SearchOutlined,
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined
} from '@ant-design/icons';

const urlList = {
  list: API_MASTERMATERIALS.LIST,
  getbyId: API_MASTERMATERIALS.GetById,
  delete: API_MASTERMATERIALS.DELETE
};

// const method = {
//   Method: 'GET'
// };

const MaterialList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);

  const translationCache = props.translationCache || [];
  // const userProfile = props.userProfile || {};

  const config = {
    title: translation(translationCache, 'Material'),
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['Material'],
    firstTitle: 'Material',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/MaterialDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const dataSource = await getMasterList(urlList.list);
      setDataSource(dataSource);
    };
    fetchData();
  }, []);

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(translationCache, `Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(translationCache, 'Search')}
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(translationCache, 'Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const _deleteById = async (id) => {
    await deleteMaster(urlList.delete, id);
    const dataSource = await getMasterList(urlList.list);
    setDataSource(dataSource);
  };

  const _editRecord = (record) => {
    props.navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  const columns = [
    {
      title: translation(translationCache, constant.material),
      dataIndex: 'Material',
      key: 'Material',
      filter: true,
      ...getColumnSearchProps('Material')
    },
    {
      title: translation(translationCache, constant.description),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation(translationCache, constant.storeLocation),
      dataIndex: 'StoreLocation',
      key: 'StoreLocation',
      filter: true
    },
    {
      title: translation(translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button onClick={() => _editRecord(record)} style={{ marginRight: "10px" }}>
            <Tooltip title={translation(translationCache, 'Edit')}>
              <EditOutlined />
            </Tooltip>
          </Button>
          <Popconfirm
            title={translation(translationCache, constant.areYouSureThatYouWantToDeleteTheMaterialMaster)}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => _deleteById(record.Id)}
            okText={translation(translationCache, constant.yes)}
            cancelText={translation(translationCache, constant.no)}
          >
            <Button >
              <Tooltip title={translation(translationCache, 'Delete')}>
                <DeleteOutlined />
              </Tooltip>
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <ListView
      {...props}
      columns={columns}
      dataSource={dataSource}
      config={config}
      delete={_deleteById}
    />
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.userProfile,
});

export default connect(mapStateToProps)(MaterialList);